export const iconFontAwesomeGamingDAndD = (
	<i className="fa-solid fa-d-and-d"></i>
);
